import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import { AITopicsByPerson } from '../ai-topics';
import { type AITopicsByPersonProps } from '../ai-topics/ai-topics-by-person';

// TODO pass layout spacing as a wrapper into the component to render conditionally only it topics are present
const TopicsContainerStyles = xcss({
	// marginTop: 'space.negative.200', // negative margins to pull topics card into place
	// marginBottom: 'space.050',
});

export const KnowledgeCardsTopics = (props: AITopicsByPersonProps) => {
	return (
		<Box xcss={TopicsContainerStyles}>
			<AITopicsByPerson {...props} />
		</Box>
	);
};
